export const PRESENCE_HEARTBEAT_MS = 60 * 1000

export const PRESENCE_MIN_INTERVAL_MS = 30 * 1000

export const IDLE_TIMEOUT_MS = 5 * 1000

export const SITE_VISIT_DAY_KEY = 'agm-site-visit-day'

const CHECKOUT_ROUTES = ['panier-livraison', 'panier-paiement']

const parisDayFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Paris',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

export const routeBaseName = name => String(name || '').split('___')[0]

export const isCheckoutRoute = name =>
  CHECKOUT_ROUTES.includes(routeBaseName(name))

export const cartHasItems = cart =>
  Array.isArray(cart?.order_variants) && cart.order_variants.length > 0

export const isExcludedVisitor = ({ staff, adminLoggedInUser }) =>
  Boolean(staff) || Boolean(adminLoggedInUser)

export const parisDayKey = date => parisDayFormatter.format(date)

export const shouldSendVisit = (sentDay, today) => sentDay !== today

export const shouldSendPresence = (last, next, now) => {
  if (!last) return true
  if (
    last.cart !== next.cart ||
    last.checkout !== next.checkout ||
    last.loggedIn !== next.loggedIn
  ) {
    return true
  }
  return now - last.at >= PRESENCE_MIN_INTERVAL_MS
}
